module.exports = __webpack_public_path__ + "static/media/front.752813c2.jpg";